<template>
  <v-app>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
useHead({
  title: 'Select Solutions',
});
</script>
